<template>
  <el-row>
    this is 迎新
  </el-row>
</template>

<script>
export default {}
</script>

<style></style>
